import React, { useCallback, useEffect, useState } from 'react';

import ConfirmActionModal from 'adapter/in/common/components/ConfirmActionModal/ConfirmActionModal';

import useWidget from 'adapter/in/dashboards/context/Widget/data';
import i18n from 'asset/translation';
import { useCase } from 'adapter/in/common/hooks/useCase';
import { dispatchWidgetsView } from 'adapter/in/dashboards/context/Widgets/view';
import { DeleteDashboardAnalysisCriteriaBuilder } from 'use-case/analysis/deleteDashboardAnalysis/deleteDashboardAnalysisCriteria';
import { isSome } from 'fp-ts/lib/Option';
import gtmIds from 'adapter/in/dashboards/config/gtm';

const gtm = gtmIds.widget.deleteModal;
export const useOnDeleteDashboardAnalysisModal = (dashboardId: string, analysisId: string) => {
    const { deleteDashboardAnalysis } = useWidget();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const { data, execute: remove, error, isLoading, reset } = useCase(deleteDashboardAnalysis, false);
    const { toggleReloadWidgets } = dispatchWidgetsView();

    const handleOnDelete = () => {
        setShowDeleteModal(true);
    };

    const handleDelete = useCallback(
        () => remove(DeleteDashboardAnalysisCriteriaBuilder.create().withAnalysisId(analysisId).withDashboardId(dashboardId).build()),
        []
    );
    useEffect(() => {
        if (isSome(data)) {
            toggleReloadWidgets(true);
            reset();
            setShowDeleteModal(false);
        }
    }, [data]);

    const onDeleteModal = (
        <ConfirmActionModal
            isOpen={showDeleteModal}
            onClose={() => {
                setShowDeleteModal(false);
                reset();
            }}
            mainButton={() => {
                handleDelete();
            }}
            hasError={isSome(error)}
            isLoading={isLoading}
            message={i18n.t('widgets.delete.warningMsg')}
            title={i18n.t('widgets.actionDelete')}
            mainButtonText={i18n.t('widgets.delete.yes')}
            mainButtonVariant='destructive'
            dataIdContext={{
                main: gtm.analysisActions.delete,
                cancel: gtm.analysisActions.cancel,
                tryAgain: gtm.analysisActions.tryAgain,
            }}
        />
    );

    return { handleOnDelete, onDeleteModal };
};
